import React from 'react';
let Error = ()=>{
    return(
        <>
         No page found
        </>
    )
}
export default  Error;